export default __webpack_public_path__ + "static/media/0174.2e4cce7f.png";